module.exports = __webpack_public_path__ + "static/media/user-profile.d8a4d03b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user-profile.svg
// module id = 765
// module chunks = 0